export type Brand = 'toyota' | 'lexus' | 'kinto'

export type GroupInfo = {
  groupUuid: string
  groupName: string
}

const getApiBrand = (brand: Brand): 'toyota' | 'lexus' =>
  brand === 'kinto' ? 'toyota' : brand

export const fetchGroupName = async (
  uuid: string,
  brand: Brand,
): Promise<string> => {
  const apiBrand = getApiBrand(brand)
  const url = `https://kong-proxy-intranet.toyota-europe.com/dxp/dealers/api/${apiBrand}/gb/en/operating-companies/all?uuid=${uuid}`

  try {
    const response = await fetch(url)
    if (!response.ok) {
      throw new Error('Network response was not ok')
    }
    const res = await response.json()
    const group = res.operatingCompanies.filter((i) => i.uuid === uuid)
    return group[0]?.name || 'Unknown Group'
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to fetch group name:', error)
    return 'Unknown Group'
  }
}

export const fetchDealerGroup = async (
  uuid: string,
  brand: Brand,
): Promise<GroupInfo | null> => {
  const apiBrand = getApiBrand(brand)
  const dealerUrl = `https://kong-proxy-intranet.toyota-europe.com/dxp/dealers/api/${apiBrand}/gb/en/details/${uuid}`

  try {
    const dealerResponse = await fetch(dealerUrl)
    if (dealerResponse.ok) {
      const dealerData = await dealerResponse.json()
      const parentUuid = dealerData?.parent

      if (parentUuid) {
        const groupName = await fetchGroupName(parentUuid, brand)
        return {
          groupUuid: parentUuid,
          groupName,
        }
      }
    }

    const groupName = await fetchGroupName(uuid, brand)
    if (groupName !== 'Unknown Group') {
      return {
        groupUuid: uuid,
        groupName,
      }
    }

    return null
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to fetch dealer group:', error)
    return null
  }
}
